import React from "react";
import styles from "./IconButton.module.css";
import Button from "common/Button";

const IconButton = ({
  icon,
  buttonFunction,
  buttonLabel,
  overrideButtonStyles = {},
  overrideButtonStylesPackage = {},
  label,
}) => {
  return (
    // <div className={buttonLabel === "Add package" ? `${styles.overrideButtonStylesPackage}`: `${overrideButtonStyles}`}>
    <div className={`${overrideButtonStyles}`}>
      <span className={styles.buttonWrapper}>
        <img
          src={`/icons/${icon}.svg`}
          alt=""
          className={styles.preButtonIcon}
        />
        <Button
          label={buttonLabel ? buttonLabel : label}
          onClick={buttonFunction}
          buttonOverrideInlineStyle={{
            background: "white",
            height: "4rem",
            width: "fit-content",
            paddingLeft: "37px",
            fontFamily: "Medium",
          }}
        />
      </span>
    </div>
  );
};

export default React.memo(IconButton);
